<template>
  <LogoutBtn :auth-model="model" :title="title" @on-logout="useManagerLogout" />
</template>

<script lang="ts" setup>
  // Types
  import type { TManagerAuthStore } from '~/modules/manager/auth/store/types';
  import type { TManager } from '~/modules/manager/types';
  import type { ManagerAuthModel as ManagerAuthModelType } from '~/modules/manager/auth/models/auth';

  // Store
  import { useManagerAuthStore } from '~/modules/manager/auth/store';

  // Models
  import { ManagerAuthModel } from '~/modules/manager/auth/models/auth';

  // Composables
  import { useManagerLogout } from '~/modules/manager/auth/composables/use-logout';

  // Components
  import LogoutBtn from '~/misc/btn/logout/LogoutBtn.vue';

  const authStore: TManagerAuthStore = useManagerAuthStore();

  const model: ManagerAuthModelType = new ManagerAuthModel();

  const user: ComputedRef<TManager | null> = computed<TManager | null>(() => authStore.user);

  const title: ComputedRef<string> = computed<string>(() => {
    if (!user.value) return 'Logout';

    return `${user.value.name} (logout)`;
  });
</script>
